import { render } from "./NewsHomePage.vue?vue&type=template&id=f7ee62e2&scoped=true"
import script from "./NewsHomePage.vue?vue&type=script&lang=js"
export * from "./NewsHomePage.vue?vue&type=script&lang=js"

import "./NewsHomePage.vue?vue&type=style&index=0&id=f7ee62e2&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7ee62e2"]])

export default __exports__